import { render, staticRenderFns } from "./AboutBannersView.vue?vue&type=template&id=fe816534&scoped=true"
import script from "./AboutBannersView.vue?vue&type=script&lang=ts"
export * from "./AboutBannersView.vue?vue&type=script&lang=ts"
import style0 from "./AboutBannersView.vue?vue&type=style&index=0&id=fe816534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe816534",
  null
  
)

export default component.exports